import { render, staticRenderFns } from "./VehiculeFormIdentity.vue?vue&type=template&id=3740b340&"
import script from "./VehiculeFormIdentity.vue?vue&type=script&lang=js&"
export * from "./VehiculeFormIdentity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports